// PageHead — the unified page header row: breadcrumb on the left, an action
// slot on the right (typically the R.I.S.A "Ask Risa" trigger). Sits at the
// top of Dashboard / Portfolio / Manage. Generic: the action is injected.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { Breadcrumb } from '../navigation/Breadcrumb';
import './page-head.css';

export function PageHead({ trail, onNavigate, action, className }) {
  return (
    <div className={cx('page-head', className)}>
      <Breadcrumb trail={trail} onNavigate={onNavigate} />
      {action && <div className="page-head__action">{action}</div>}
    </div>
  );
}

PageHead.propTypes = {
  trail: PropTypes.array,
  onNavigate: PropTypes.func,
  /** Right-aligned slot (e.g. GenieTrigger). */
  action: PropTypes.node,
  className: PropTypes.string,
};

export default PageHead;
